import { apiFetch } from '@ami/react/core';
import ThumbBucketProfileFilter from './ThumbBucketProfileFilter';
import ThumbBucketProfile from './ThumbBucketProfile';
import ThumbBucketProfileView from './ThumbBucketProfileView';

const _baseEndPoint = 'thumb-bucket-profiles';

export default {
  search: async (filter = new ThumbBucketProfileFilter(), page) => {
    filter.setPaginationParameters(page);
    const result = await apiFetch(`${_baseEndPoint}?${filter.toQueryString()}`);
    return result;
  },
  get: async (id) => {
    const entity = await apiFetch(`${_baseEndPoint}/${id}`);
    return new ThumbBucketProfile(entity);
  },
  getView: async (id) => {
    const entity = await apiFetch(`${_baseEndPoint}/${id}/view`);
    return new ThumbBucketProfileView(entity);
  },
  getToothStyleType: () => {
    return apiFetch(`${_baseEndPoint}/tooth-styles`);
  },
};
